export default __webpack_public_path__ + "images/Format.d7322efd807f7387346a48c2b35489bd.svg";